import React from 'react';
import { CTAButton } from '../CTAButton';
export function About() {
  return <section className="w-full bg-navy-950 px-4 py-14 text-white sm:px-6 sm:py-20" data-id="element-47" data-mp="or48z8g6lnzz">
      <div className="mx-auto w-full max-w-4xl" data-id="element-48" data-mp="oti2vdz4ku5y">
        <div className="grid items-start gap-8 lg:grid-cols-[minmax(0,300px)_minmax(0,1fr)]" data-id="element-49" data-mp="12pvngvyyhbon">
          <figure className="mx-auto w-full max-w-[300px]" data-id="element-50" data-mp="yqd1dwveeuk8">
            <img src="https://cdn.magicpatterns.com/uploads/pvkUd9VySojivy43Qifkes/Dra._Karito_Odontologa.png" alt="Dr. Karito, dentist and creator of the Clinical Master System" className="w-full rounded-3xl border border-white/10 object-cover" loading="lazy" data-id="element-51" data-mp="azqvab4yfkcv" />
            <figcaption className="mt-3 text-center text-[12px] font-bold uppercase tracking-[0.16em] text-gold-400" data-id="element-52" data-mp="f12kifjx23kj">
              Dr. Karito — Dentist
            </figcaption>
          </figure>

          <div data-id="element-53" data-mp="3jgc5twd8ili3">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gold-400" data-id="element-54" data-mp="3jerbo7uu14kr">
              👩‍⚕️ About Dr. Karito
            </p>
            <h2 className="mt-3 font-display text-[27px] font-bold leading-[1.15] sm:text-4xl" data-id="element-55" data-mp="337e15ayyd36t">
              Why I Created the Clinical Master System™
            </h2>
            <div className="mt-5 space-y-3.5 text-[14.5px] leading-relaxed text-white/70" data-id="element-56" data-mp="3czjrkg9k3cjw">
              <p data-id="element-57" data-mp="3hxlcl6qjlly0">
                A good clinical decision starts long before treatment begins. It starts with knowing
                what to evaluate, how to interpret what you find and which information deserves your
                attention first.
              </p>
              <p data-id="element-58" data-mp="2u8aj8abiuttw">
                The problem is that most dentists were never given a simple, repeatable framework
                for doing this. You learn hundreds of individual concepts throughout dental school
                and continuing education. But when you’re sitting in front of a real patient with
                multiple findings, the question becomes:
              </p>
              <p className="font-display text-xl italic text-gold-300" data-id="element-59" data-mp="2ak161os4y0tz">
                “What do I evaluate first?”
              </p>
              <p data-id="element-60" data-mp="25ko92b7jvddo">
                That’s why I created the Clinical Master System™. Not as another theoretical course,
                but as a practical clinical library built around protocols, decision trees,
                checklists and case-based resources.
              </p>
              <p className="font-bold text-white" data-id="element-61" data-mp="1rv4brkwqn8br">
                My goal is simple: help you stop improvising your diagnostic process and start
                following a clear clinical system.
              </p>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-md" data-id="element-62" data-mp="1vvo7ck1ny3vs">
          <CTAButton label="I want to follow this system" data-id="element-63" data-mp="1vuuy9cf8f2ah" />
        </div>
      </div>
    </section>;
}